import { cn, tv, VariantProps } from "@utils/tw"
import { AnimatePresence, motion } from "motion/react"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren<{
  className?: string
}> &
  VariantProps<typeof createStyles>

export function Message(props: Props) {
  const styles = createStyles(props)
  return (
    <AnimatePresence>
      {!!props.children && (
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className={cn(styles.message(), props.className)}
        >
          {props.children}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

const createStyles = tv({
  base: "",
  slots: {
    message: "py-[0.5em] px-[0.8em] bg-fg text-bg type-ui-m",
  },
  variants: {
    variant: {
      error: {
        message: "bg-coral text-white",
      },
    },
  },
})
